import { render, staticRenderFns } from "./SectionFeaturedCourses.vue?vue&type=template&id=0d280094&scoped=true"
import script from "./SectionFeaturedCourses.vue?vue&type=script&lang=js"
export * from "./SectionFeaturedCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d280094",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkBtnIcon: require('/builds/marketing/abstracta.academy-website/components/LinkBtnIcon.vue').default})
